// extracted by mini-css-extract-plugin
export default {"stickyHeader":"ZFduuGlh","_isSticked":"ss9IuH1Q","_withShadow":"eAm0RO1D","_toHide":"vsTFgNWG","_toShow":"EKkVHNwO"};